/** Single placeholder for a missing value in the UI. */
export const EMPTY_DISPLAY = '—';

const EMPTY_MARKS = new Set(['', '-', '–', '—']);

export function isEmptyDisplay(value: string | null | undefined): boolean {
  return value == null || EMPTY_MARKS.has(value.trim());
}
